<!-- 買掛金現金支払の登録 -->
<template>
  <el-table
    :data="blendData"
    class="egl-table"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    stripe
  >
    <!-- 請求件名 -->
    <el-table-column
      prop="requestId"
      :label="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.th.billingSubject')"
      min-width="130"
      align="center"
    >
      <template slot-scope="scope">
        <el-select
          v-if="!scope.row.totalRow"
          v-model="tableData[scope.$index].requestId"
          :placeholder="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.billingSubjectPlaceHolder')"
          :clearable="true"
          @change="val => changeRequestName(val, scope.$index)"
        >
          <el-option
            v-for="item in paymentList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div v-else class="ta-r">{{ $locale("accountReceivable.totalAmount") }}</div>
      </template>
    </el-table-column>
    <!-- 請求明細 -->
    <el-table-column
      prop="requestDetailsId"
      :label="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.th.billingDetail')"
      min-width="100"
      align="center"
    >
      <template slot-scope="scope">
        <el-select
          v-model="tableData[scope.$index].requestDetailsId"
          :placeholder="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.billingDetailPlaceHolder')"
          :clearable="true"
          @change="val => changeRequestDetails(val, scope.$index)"
        >
          <el-option
            v-for="item in paymentRequestDetails(scope.$index)"
            :key="item.itemId"
            :label="item.itemName"
            :value="item.itemId"
          ></el-option>
        </el-select>
      </template>
    </el-table-column>
    <!-- 請求締日 -->
    <el-table-column
      prop="requestDeadDate"
      :label="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.th.billingDeadline')"
      min-width="80"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.requestDeadDate | dateFormatter }}
      </template>
    </el-table-column>
    <!-- 支払予定日 -->
    <el-table-column
      prop="payDate"
      :label="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.th.paymentDueDate')"
      min-width="80"
      align="center"
    >
      <template slot-scope="scope">
        <span>{{ scope.row.payDate | dateFormatter }}</span>
      </template>
    </el-table-column>
    <!-- 買掛金残高 -->
    <el-table-column
      prop="actualAmountResidual"
      :label="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.th.accountPayableBalance')"
      min-width="100"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.actualAmountResidual | currencyFormatter }}
      </template>
    </el-table-column>
    <!-- 現金支払金額 -->
    <el-table-column
      :label="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.th.cashPaymentAmount')"
      min-width="100"
      align="center"
    >
      <template slot-scope="scope">
        <el-input
          v-if="!scope.row.totalRow"
          :value="tableData[scope.$index].cashDisbursementAmount | currencyFormatter"
          maxlength="14"
          @input="value => inputAction(value, scope.$index)"
        ></el-input>
        <template v-else>{{ scope.row.cashDisbursementAmount | currencyFormatter(true) }}</template>
      </template>
    </el-table-column>
    <!-- 支払後買掛金残高 -->
    <el-table-column
      prop="accountsPayableAfter"
      :label="$locale('dailyClosing.createDialog.accountsPayableCashPaymentRegistrationTable.th.accountPayableBalanceAfterPayment')"
      min-width="100"
      align="center"
    >
      <template slot-scope="scope">
        <template v-if="!scope.row.totalRow">{{ scope.row.accountsPayableAfter | currencyFormatter }}</template>
      </template>
    </el-table-column>

    <el-table-column>
      <template slot-scope="scope">
        <div class="handle ctrl" v-if="!scope.row.totalRow">
          <el-button
            v-if="tableData.length > 1 && scope.$index < tableData.length"
            class="handle-btn egl-btn-white"
            icon="el-icon-minus"
            @click="removeTableDataAction(scope.$index)"
          ></el-button>
          <el-button
            v-if="scope.$index === tableData.length - 1"
            class="handle-btn egl-btn-white"
            icon="el-icon-plus"
            @click="addTableDataAction"
          ></el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { digtalParser } from "@/utils/common";
import { accountsPaymentBaseStruct } from "@/assets/js/dailyClosingNew";

export default {
  name: "AccountsPayableCashPaymentRegistrationTable",
  props: {
    paymentList: {
      type: Array,
      default: () => [],
    },
    clientList: {
      type: Array,
      default: () => [],
    },
    tableData: {
      required: true,
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      if (this.tableData.length === 0) {
        this.addTableDataAction();
      }

      let resultArray = tranfResData(this.tableData);

      resultArray.forEach(_item => {
        const { requestDeadDate, payDate } = _item;

        if (!requestDeadDate) {
          _item.requestDeadDate = null;
        }

        if (!payDate) {
          _item.payDate = null;
        }
      });

      const _total = resultArray.map(_list => _list.cashDisbursementAmount).reduce((prev, cur) => {
        return Number(prev) + Number(cur);
      });

      const _base = accountsPaymentBaseStruct();
      resultArray.push({
        ..._base,
        totalRow: true,
        cashDisbursementAmount: _total,
      });

      return resultArray;
    },
  },
  methods: {
    paymentRequestDetails(idx) {
      if (this.paymentList.length === 0) {
        return [];
      }

      const { currentPaymentIndex } = this.tableData[idx];
      const _target = this.paymentList[currentPaymentIndex];
      const _resultArray = _target ? _target.records : [];
      return _resultArray;
    },
    inputAction(value, idx) {
      let _value = digtalParser(value);

      if (this.tableData[idx]) {
        this.tableData[idx].cashDisbursementAmount = _value;
        this.tableData[idx].accountsPayableAfter = this.tableData[idx].actualAmountResidual - Number(_value);
      }
    },
    spanMethod({ columnIndex, row }) {
      if (row.totalRow) {
        if (columnIndex === 0) {
          return [1, 4];
        } else if (columnIndex < 4) {
          return [0, 0];
        }
      }
    },
    rowClassName({ row }) {
      if (row.totalRow) {
        return "total-row";
      }
      return "";
    },
    addTableDataAction() {
      const _base = accountsPaymentBaseStruct();
      _base.currentPaymentIndex = -1;
      this.tableData.push(_base);
    },
    removeTableDataAction(index) {
      this.tableData.splice(index, 1);
    },
    changeRequestName(_selectId, _idx) {
      const _tableData = tranfResData(this.tableData);

      if (_selectId) {
        const _targetIdx = this.paymentList.findIndex(_list => _list.id === _selectId);

        _tableData[_idx].currentPaymentIndex = _targetIdx;
        _tableData[_idx].requestName = this.paymentList[_targetIdx] ? this.paymentList[_targetIdx].name : "";        
      } else {
        const _base = accountsPaymentBaseStruct();
        _tableData[_idx] = {
          ..._base,
          currentPaymentIndex: -1,
        };
      }

      this.$emit("update:tableData", _tableData);
    },
    changeRequestDetails(_selectId, _idx) {
      const _tableData = tranfResData(this.tableData);
      const { requestId, currentPaymentIndex } = _tableData[_idx];

      if (_selectId) {
        const _currentPayment = this.paymentList[currentPaymentIndex];
        const { records } = _currentPayment;
        const _targetObj = records.find(_rec => _rec.itemId === _selectId);
        const {
          actualAmountResidual,
          depositDate,
          requestDeadDate,
          itemName,
        } = _targetObj;

        _tableData[_idx] = {
          ..._tableData[_idx],
          accountsPayableAfter: 0,
          actualAmountResidual,
          cashDisbursementAmount: actualAmountResidual,
          payDate: depositDate,
          requestDeadDate,
          requestDetails: itemName,
        };
      } else {
        const _base = accountsPaymentBaseStruct();

        _tableData[_idx] = {
          ..._base,
          requestId,
          currentPaymentIndex,
        };
      }

      this.$emit("update:tableData", _tableData);
    },
  },
};
</script>
